import { useEffect, useState } from "react";

type ModalScrollerMessageHandler = (event: MessageEvent) => void;

export const useBuiltInModalScroller = () => {
  const [pixels, setPixels] = useState(0);

  useEffect(() => {
    const onMessage: ModalScrollerMessageHandler = (e) => {
      if (e.data?.type === "PARENT_SCROLL") {
        setPixels(e.data.scrollY);
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  useEffect(() => {
    const applyTop = (root: ParentNode | Document = document) => {
      root
        .querySelectorAll<HTMLElement>(".rodal-dialog")
        .forEach((el) => (el.style.top = `${pixels}px`));
    };

    applyTop();

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;

        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.classList.contains("rodal-dialog")) {
            node.style.top = `${pixels}px`;
            return;
          }

          const nested = node.querySelectorAll<HTMLElement>(".rodal-dialog");
          nested.forEach((el) => (el.style.top = `${pixels}px`));
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pixels]);
};
